import React, { useState, useCallback, useEffect, memo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import classNames from 'classnames';
import ASoftCard from '../../components/ASoftCard/ASoftCard';
import { getARecommendSoft } from '../../actions/arecommend';
import { logging } from '../../actions/log';
import styles from './ATab.module.less';

const selectRecommendsSoft = createSelector(
  state => state.arecommend,
  arecommend => arecommend.recommendsSoft,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectLocalSoftsInit = createSelector(
  state => state.native,
  native => native.installedSoftInit,
);

export default memo(() => {
  const dispatch = useDispatch();
  const recommendsSoftData = useSelector(selectRecommendsSoft);
  const logInfoData = useSelector(selectLogInfo);
  const localSoftsInit = useSelector(selectLocalSoftsInit);
  const pageSize = 9;

  const [activitIndex, setActivitIndex] = useState(0);
  const [activitRecommends, setActivitRecommends] = useState({});
  const [showSoft, setShowSoft] = useState([]);
  const [showSoftPage, setShowSoftPage] = useState(0);

  const filterSoft = (activitRecommends_, localSoftsInit_) => {
    const showSoftAll = [];
    if (activitRecommends_.apps && activitRecommends_.apps.length > 0) {
      activitRecommends_.apps.forEach(item => {
        const found = localSoftsInit_.find(
          soft =>
            (item.androidType !== '1' &&
              (soft.softID === item.softID || soft.softID === item.SoftID)) ||
            (item.androidType === '1' && soft.packageName === item.packageName),
        );
        if (found === undefined) {
          showSoftAll.push(item);
        }
      });
    }
    return showSoftAll;
  };
  /**
   * 每一次change 都是数组中循环展示6个  不够就用数组前面的应用组装成6个  这样依次循环展示
   * 根据保存的页码数，获取当前应该展示的6个应用
   */
  const getAppsByPage = (softAll, page) => {
    if (softAll && softAll.length === 0) {
      return [];
    }
    let softArrLoop = softAll;
    while (page * pageSize > softArrLoop.length) {
      softArrLoop = softArrLoop.concat(softAll);
    }
    return softArrLoop.slice((page - 1) * pageSize, page * pageSize);
  };

  /**
   * 每一次change 都是数组中循环展示6个  不够就用数组前面的应用组装成6个  这样循环展示
   */
  const handleChangeSoft = (activitRecommends_, localSoftsInit_, showSoftPage_, flag) => {
    const showSoftAll = filterSoft(activitRecommends_, localSoftsInit_);
    const show_Soft = getAppsByPage(showSoftAll, showSoftPage_ + 1);
    setShowSoftPage(showSoftPage_ + 1);
    setShowSoft(show_Soft);

    // 推荐页面 换一换 点击打桩
    if (!flag) {
      dispatch(
        logging({
          category: 'C',
          action: 'A_Hchange',
          label: '',
          param2: {
            source: `A_Reco_tab||${activitRecommends_.code}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
    }
  };

  const handleChangeMenu = useCallback(
    (activitIndex_, activitRecommends_, localSoftsInit_, flag) => {
      if (activitRecommends_) {
        setActivitIndex(activitIndex_);
        setActivitRecommends(activitRecommends_);
        setShowSoftPage(0); // 设置换一换第1页
        handleChangeSoft(activitRecommends_, localSoftsInit_, 0, true);
      }

      // 推荐页面 推荐页_精品推荐_menu 点击打桩
      if (!flag) {
        dispatch(
          logging({
            category: 'C',
            action: 'A_Reco_tab',
            label: '',
            param2: {
              source: `A_Reco_tab||${activitRecommends_.code}`,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
            },
          }),
          [dispatch],
        );
      }
    },
    [dispatch],
  );

  useEffect(() => {
    if (!recommendsSoftData || !recommendsSoftData.softRecommends) {
      dispatch(getARecommendSoft());
    } else {
      handleChangeMenu(0, recommendsSoftData.softRecommends[0], localSoftsInit, true);
    }
  }, [dispatch, recommendsSoftData, localSoftsInit]);

  return (
    showSoft &&
    recommendsSoftData.softRecommends && (
      <div className={styles.softTab}>
        <div className={styles.softTab_header}>
          <div className={styles.header_menu}>
            <div className={styles.softTab_header_title}>精品推荐</div>
            {recommendsSoftData.softRecommends.map((menu, i) => (
              <div
                className={
                  activitIndex === i ? styles.header_menu_item_activit : styles.header_menu_item
                }
                key={i}
                onFocus={() => undefined}
                onMouseOver={() => {
                  handleChangeMenu(i, menu, localSoftsInit);
                }}
              >
                {menu.name}
              </div>
            ))}
          </div>
          {filterSoft(activitRecommends, localSoftsInit).length > pageSize && (
            <div
              className={styles.softTab_header_link}
              onClick={() => {
                handleChangeSoft(activitRecommends, localSoftsInit, showSoftPage);
              }}
            >
              <i className={classNames(styles.refresh_icon, 'iconfont icon-refresh1')} />
              <span>换一换</span>
            </div>
          )}
        </div>
        <div className={styles.softTab_soft}>
          <div className={styles.soft_cards}>
            {showSoft &&
              showSoft.length > 0 &&
              showSoft.map((soft, j) => (
                <ASoftCard
                  soft={soft}
                  logInfo={{ source: `A_Reco_tab||${activitRecommends.code}` }}
                  key={j}
                />
              ))}
          </div>
        </div>
      </div>
    )
  );
});
